// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"854c739f","64":"b8a65eea","132":"3f3b5e44","213":"29388586","226":"681b4ef4","334":"61f1837a","453":"c21b52cb","501":"e916487b","563":"7fa7688c","580":"0a689f24","669":"b8292a69","732":"65242dc0","937":"279a4397","947":"b3cfef61","984":"89c70c54"}[chunkId] + ".chunk.js";
};